import { useQuery } from '@tanstack/react-query-v4'
import { useApi } from '@api/useApi.hook'
import { QueryKey } from '@api'
import { appConfig } from '@config'
import { useIsAuthenticated } from '@domain/auth/Auth.context'
import { useWeb3Ready } from '@domain/auth/context/Web3ReadyContext'
import type { CartResponseDto } from './cart.types'

export const useCart = () => {
  const { get } = useApi()
  const isAuthenticated = useIsAuthenticated()
  const web3Ready = useWeb3Ready()
  const isReady = isAuthenticated && (web3Ready?.ready ?? false)

  return useQuery({
    queryKey: [QueryKey.Cart, isAuthenticated, isReady],
    enabled: isReady,
    queryFn: async (): Promise<CartResponseDto> => {
      const response = await get<CartResponseDto>(appConfig.endpoints.v1.cart.main)()
      return response || { items: [] }
    },
  })
}
